import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	makes: [],
	selectedMakes: [],
	hasLoaded: false
};

const makeSlice = createSlice({
	name: 'make',
	initialState,
	reducers: {
		makesLoaded(state, action) {
			// eslint-disable-next-line no-param-reassign
			state.makes = Array.isArray(action.payload) ? action.payload : [];
		},

		makesResolved(state) {
			// eslint-disable-next-line no-param-reassign
			state.hasLoaded = true;
		},

		toggleMake(state, action) {
			const value = action.payload;
			const idx = state.selectedMakes.indexOf(value);
			if (idx === -1) {
				state.selectedMakes.push(value);
			} else {
				state.selectedMakes.splice(idx, 1);
			}
		},

		resetMakes(state) {
			// eslint-disable-next-line no-param-reassign
			state.selectedMakes = [];
		},

		setSelectedMakes(state, action) {
			// eslint-disable-next-line no-param-reassign
			state.selectedMakes = Array.isArray(action.payload)
				? action.payload
				: [];
			}
	}
});

export const { makesLoaded, makesResolved, toggleMake, resetMakes, setSelectedMakes } =
	makeSlice.actions;

export default makeSlice.reducer;
